import React, { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import { getDataById } from "../../utility/adminApi";
import ProductView from "./ProductView";
import useDefaultCurrency from "../../utility/useDefaultCurrency";
import ImageWithPlaceholder from "../../components/ImageWithPlaceholder";
import { formatNumbersWithDecimal } from "../../components/formatNumbersWIthDecimal";

function ProductsTableBody({
  productData,
  setSingleData,
  setEdittab,
  handleDelete,
}) {
  const { data, error } = useDefaultCurrency("admin");
  const [currency, setCurrency] = useState(null);

  const handleSingleFile = async (id, setEditTab = false) => {
    const response = await getDataById("products/show/", id);
    setSingleData(response?.data?.data);
    if (setEditTab) {
      setEdittab(true);
    } else {
      // setViewFile(true)
    }
  };

  useEffect(() => {
    setCurrency(data?.currency?.symbol);
  }, [data]);

  return (
    <tbody>
      {productData.map((item) => (
        <tr
          key={item.id}
          className="hover:bg-gray-100 border-b border-gray-300"
        >
          <td className="  py-2 flex justify-center">
            <ImageWithPlaceholder
              item={item}
              className="w-10 h-10 rounded-md object-cover"
              placeholderClassName="w-10 h-10 bg-slate-400 text-white flex justify-center font-medium items-center rounded-md text-xl"
            />
          </td>
          <td className="py-2 px-4 text-center text-wrap">
            {item?.product_name}
          </td>

          <td className="py-2 px-4 text-center text-wrap">
            {item?.available_quantity}
          </td>

          <td className="py-2 px-4 text-center text-wrap">
            {currency}
            {formatNumbersWithDecimal(item?.price)}
          </td>
          <td className="py-2 px-4 text-center text-wrap">
            {item?.category?.cat_name}
          </td>
          <td className="py-2  flex justify-center gap-3">
            <EditIcon
              onClick={() => handleSingleFile(item.id, true)}
              className="text-blue-500 cursor-pointer"
            />
            <ProductView item={item} currency={currency} />
            <DeleteIcon
              onClick={() => handleDelete(item.id)}
              className="text-red-500 cursor-pointer"
            />
          </td>
        </tr>
      ))}
    </tbody>
  );
}

export default ProductsTableBody;
